( function ($) {
    $(document).ready(function () {
        var wraps = $('.children_section');
        wraps.each(function () {
            var wrap = $(this);
            bookYourRoom(wrap.find('.item_wrap'));
        })
    });

    function bookYourRoom(container){
        var book_your_room = container.find('.book-your-room .book-now');
        if(book_your_room.length > 0){
            book_your_room.each(function(){
                var btn = $(this);
                btn.on('click', function(){
                    dedgeBookingInstance.getProvider().bookNow({
                        hotelId: $(this).attr('data-room-type')
                    });
                });
            });
        }
    }
}(jQuery) );
